import "./icon.scss";
function Icon({ size, position, projct, src, onClick , hide , Link }) {

  return (
    <div onClick={onClick} className={`icon-card icon-card-${size} icon-card-${hide}`}>
      <img
        className={`icon icon-${position} icon-${projct} icon-${hide}`}
        src={src}
        alt=""
      />
    </div>
  );
}
export default Icon;
